// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.0
//   protoc               v3.20.3
// source: chat_session.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { AnalysisTreeProto } from "./analysis";
import { AnalysisPlanProto, KGObservationProto } from "./analysis_plan";
import { AnalystProto, ScenarioAnalysis } from "./analyst";
import {
  ArtifactType,
  artifactTypeFromJSON,
  artifactTypeToJSON,
  ChatMessageType,
  chatMessageTypeFromJSON,
  chatMessageTypeToJSON,
  DarwinAgentType,
  darwinAgentTypeFromJSON,
  darwinAgentTypeToJSON,
  DarwinHeader,
  ExecutionStatusType,
  executionStatusTypeFromJSON,
  executionStatusTypeToJSON,
} from "./common";
import { CustomAgentProto } from "./custom_agent";
import { ArgsSchemaType, argsSchemaTypeFromJSON, argsSchemaTypeToJSON } from "./darwin_agent";
import { KGDataFrameProto } from "./dataframe";
import { Header } from "./metadata";
import { ScheduledJobProto } from "./schedule";

export const protobufPackage = "com.anko.darwin";

/** Client types */
export enum ChatClientType {
  UNKNOWN_CLIENT_TYPE = 0,
  EVA = 1,
  FRIDA = 2,
  SLACK = 3,
  SCHEDULED = 4,
  UNRECOGNIZED = -1,
}

export function chatClientTypeFromJSON(object: any): ChatClientType {
  switch (object) {
    case 0:
    case "UNKNOWN_CLIENT_TYPE":
      return ChatClientType.UNKNOWN_CLIENT_TYPE;
    case 1:
    case "EVA":
      return ChatClientType.EVA;
    case 2:
    case "FRIDA":
      return ChatClientType.FRIDA;
    case 3:
    case "SLACK":
      return ChatClientType.SLACK;
    case 4:
    case "SCHEDULED":
      return ChatClientType.SCHEDULED;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChatClientType.UNRECOGNIZED;
  }
}

export function chatClientTypeToJSON(object: ChatClientType): string {
  switch (object) {
    case ChatClientType.UNKNOWN_CLIENT_TYPE:
      return "UNKNOWN_CLIENT_TYPE";
    case ChatClientType.EVA:
      return "EVA";
    case ChatClientType.FRIDA:
      return "FRIDA";
    case ChatClientType.SLACK:
      return "SLACK";
    case ChatClientType.SCHEDULED:
      return "SCHEDULED";
    case ChatClientType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Scenario agent response output */
export interface ScenarioOutput {
  /** Status of the scenario execution */
  status?:
    | ScenarioOutput_ScenarioStatus
    | undefined;
  /** Findings from the scenario execution */
  findings?:
    | string
    | undefined;
  /** Dataframes referenced */
  kg_dataframes: KGDataFrameProto[];
}

/** Status for scenario execution */
export enum ScenarioOutput_ScenarioStatus {
  INVALID = 0,
  VALID = 1,
  WARNING = 2,
  ERROR = 3,
  UNRECOGNIZED = -1,
}

export function scenarioOutput_ScenarioStatusFromJSON(object: any): ScenarioOutput_ScenarioStatus {
  switch (object) {
    case 0:
    case "INVALID":
      return ScenarioOutput_ScenarioStatus.INVALID;
    case 1:
    case "VALID":
      return ScenarioOutput_ScenarioStatus.VALID;
    case 2:
    case "WARNING":
      return ScenarioOutput_ScenarioStatus.WARNING;
    case 3:
    case "ERROR":
      return ScenarioOutput_ScenarioStatus.ERROR;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ScenarioOutput_ScenarioStatus.UNRECOGNIZED;
  }
}

export function scenarioOutput_ScenarioStatusToJSON(object: ScenarioOutput_ScenarioStatus): string {
  switch (object) {
    case ScenarioOutput_ScenarioStatus.INVALID:
      return "INVALID";
    case ScenarioOutput_ScenarioStatus.VALID:
      return "VALID";
    case ScenarioOutput_ScenarioStatus.WARNING:
      return "WARNING";
    case ScenarioOutput_ScenarioStatus.ERROR:
      return "ERROR";
    case ScenarioOutput_ScenarioStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Scenario synthesis agent response output */
export interface NotificationOutput {
  /** Output string from synthesis */
  output_string?:
    | string
    | undefined;
  /** Whether to notify the user */
  notify?:
    | boolean
    | undefined;
  /** Reason for the notify decision */
  notify_reason?: string | undefined;
}

/** Wrapper for response tool outputs - used in ChatMessageProto for RESPONSE type messages */
export interface ResponseMessageProto {
  type?: ArgsSchemaType | undefined;
  scenario_output?: ScenarioOutput | undefined;
  scenario_synthesis_output?: NotificationOutput | undefined;
}

/** Analyst job run proto — self-contained representation of a completed job run */
export interface AnalystJobRunProto {
  /** Header (id, name, etc.) */
  header?:
    | Header
    | undefined;
  /** Scenario outputs */
  scenario_outputs: AnalystJobRunProto_ScenarioOutputEntry[];
  /** Synthesis / notification output */
  synthesis_output?: NotificationOutput | undefined;
}

/** Scenario output with its scenario ID */
export interface AnalystJobRunProto_ScenarioOutputEntry {
  scenario_id?: string | undefined;
  scenario_output?: ScenarioOutput | undefined;
}

/** Artifact: metadata about accessed resources */
export interface ArtifactProto {
  /** Artifact Type */
  artifact_type?:
    | ArtifactType
    | undefined;
  /** kg_observation structure for artifact */
  kg_observation?:
    | KGObservationProto
    | undefined;
  /** kg_dataframe structure for artifact */
  kg_dataframe?:
    | KGDataFrameProto
    | undefined;
  /** scenario structure for artifact */
  scenario?:
    | ScenarioAnalysis
    | undefined;
  /** analyst_job_run structure for artifact */
  analyst_job_run?:
    | AnalystJobRunProto
    | undefined;
  /** scenario_job structure for artifact */
  scenario_job?: ScheduledJobProto | undefined;
}

export interface ChatMessageProto {
  /** Message type */
  message_type?:
    | ChatMessageType
    | undefined;
  /** Content for simple messages (SYSTEM, HUMAN, RESPONSE) */
  content?:
    | string
    | undefined;
  /** For REASONING type: embedded child conversation as JSON strings */
  langgraph_message_json_list: string[];
  /**
   * Artifacts: map of index -> Artifact (relative to base_messages)
   * TODO: Map the artifacts to the index in langgraph message array.
   */
  artifacts: ArtifactProto[];
  /** For RESPONSE type: structured response from response tools */
  response_message?:
    | ResponseMessageProto
    | undefined;
  /** LangSmith url for this AI response */
  ls_trace_url?:
    | string
    | undefined;
  /** Unique identifier for this message */
  id?:
    | string
    | undefined;
  /** Timestamp in epoch milliseconds (created on init, updated on append for REASONING) */
  timestamp_ms?: number | undefined;
}

/** This is the master proto for inputs of all agents. */
export interface AgentInputProto {
  trees: AnalysisTreeProto[];
  plans: AnalysisPlanProto[];
  custom_agents: CustomAgentProto[];
  analyst?: AnalystProto | undefined;
  scheduled_job?:
    | ScheduledJobProto
    | undefined;
  /** Override jinja variables for Eva Playground */
  override_jinja_variables?: AgentInputProto_OverrideVariables | undefined;
  scenario_jobs: ScheduledJobProto[];
}

/** Override jinja variables, these are only set by Eva playground */
export interface AgentInputProto_OverrideVariables {
  /**
   * Date override for prompt templates default: current system datetime
   * Date format: %Y-%m-%d
   */
  today_date?:
    | string
    | undefined;
  /** variable to override company name default value comes from env */
  company_name?:
    | string
    | undefined;
  /** variable to set week start day default should be Monday */
  week_start_day?:
    | string
    | undefined;
  /** variable to set quarter start month default should be January */
  quarter_start_month?: string | undefined;
}

/** map of scenario llm_id and scenario uuid */
export interface AgentScenarioMapping {
  llm_id?: string | undefined;
  scenario_id?: string | undefined;
}

export interface ChatResponse {
  /** Session header containing session_id, name, and client_type (in type field) */
  session_header?:
    | DarwinHeader
    | undefined;
  /** Chat messages */
  messages: ChatMessageProto[];
  /** Execution status of the session */
  status?:
    | ExecutionStatusType
    | undefined;
  /** Analyst id associated with this chat session, derived from associated_entity_keys */
  analyst_id?:
    | string
    | undefined;
  /** Map of analyst scenario llm_id to scenario uuid */
  saved_scenario_agent_mapping: AgentScenarioMapping[];
}

/** Wrapper for chat initialization configuration */
export interface ChatContext {
  /** Agent type */
  agent_type?:
    | DarwinAgentType
    | undefined;
  /** Agent header */
  agent_header?:
    | DarwinHeader
    | undefined;
  /** Prompt header */
  prompt_header?:
    | DarwinHeader
    | undefined;
  /** Agent input */
  agent_input?: AgentInputProto | undefined;
}

/** Chat request message for starting/continuing conversations */
export interface ChatRequest {
  /** Session header containing session_id and client_type (in type field) */
  session_header?:
    | DarwinHeader
    | undefined;
  /**
   * Initialization config
   * Required for START (when session_header.id is not present)
   * Ignored for CONTINUE (when session_header.id is present)
   */
  chat_context?:
    | ChatContext
    | undefined;
  /**
   * User message
   * When provided with ChatContext (START): triggers agent execution
   * When provided with session_header.id (CONTINUE): continues the conversation.
   */
  message?:
    | string
    | undefined;
  /** If true, automatically saves new messages to database after execution */
  is_save?:
    | boolean
    | undefined;
  /** User context */
  user_context?: ArtifactProto | undefined;
}

function createBaseScenarioOutput(): ScenarioOutput {
  return { status: undefined, findings: undefined, kg_dataframes: [] };
}

export const ScenarioOutput: MessageFns<ScenarioOutput> = {
  encode(message: ScenarioOutput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== undefined) {
      writer.uint32(8).int32(message.status);
    }
    if (message.findings !== undefined) {
      writer.uint32(18).string(message.findings);
    }
    for (const v of message.kg_dataframes) {
      KGDataFrameProto.encode(v!, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ScenarioOutput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseScenarioOutput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.findings = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.kg_dataframes.push(KGDataFrameProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ScenarioOutput {
    return {
      status: isSet(object.status) ? scenarioOutput_ScenarioStatusFromJSON(object.status) : undefined,
      findings: isSet(object.findings) ? globalThis.String(object.findings) : undefined,
      kg_dataframes: globalThis.Array.isArray(object?.kg_dataframes)
        ? object.kg_dataframes.map((e: any) => KGDataFrameProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ScenarioOutput): unknown {
    const obj: any = {};
    if (message.status !== undefined) {
      obj.status = scenarioOutput_ScenarioStatusToJSON(message.status);
    }
    if (message.findings !== undefined) {
      obj.findings = message.findings;
    }
    if (message.kg_dataframes?.length) {
      obj.kg_dataframes = message.kg_dataframes.map((e) => KGDataFrameProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ScenarioOutput>, I>>(base?: I): ScenarioOutput {
    return ScenarioOutput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ScenarioOutput>, I>>(object: I): ScenarioOutput {
    const message = createBaseScenarioOutput();
    message.status = object.status ?? undefined;
    message.findings = object.findings ?? undefined;
    message.kg_dataframes = object.kg_dataframes?.map((e) => KGDataFrameProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseNotificationOutput(): NotificationOutput {
  return { output_string: undefined, notify: undefined, notify_reason: undefined };
}

export const NotificationOutput: MessageFns<NotificationOutput> = {
  encode(message: NotificationOutput, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.output_string !== undefined) {
      writer.uint32(10).string(message.output_string);
    }
    if (message.notify !== undefined) {
      writer.uint32(16).bool(message.notify);
    }
    if (message.notify_reason !== undefined) {
      writer.uint32(26).string(message.notify_reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): NotificationOutput {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNotificationOutput();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.output_string = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.notify = reader.bool();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.notify_reason = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): NotificationOutput {
    return {
      output_string: isSet(object.output_string) ? globalThis.String(object.output_string) : undefined,
      notify: isSet(object.notify) ? globalThis.Boolean(object.notify) : undefined,
      notify_reason: isSet(object.notify_reason) ? globalThis.String(object.notify_reason) : undefined,
    };
  },

  toJSON(message: NotificationOutput): unknown {
    const obj: any = {};
    if (message.output_string !== undefined) {
      obj.output_string = message.output_string;
    }
    if (message.notify !== undefined) {
      obj.notify = message.notify;
    }
    if (message.notify_reason !== undefined) {
      obj.notify_reason = message.notify_reason;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<NotificationOutput>, I>>(base?: I): NotificationOutput {
    return NotificationOutput.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<NotificationOutput>, I>>(object: I): NotificationOutput {
    const message = createBaseNotificationOutput();
    message.output_string = object.output_string ?? undefined;
    message.notify = object.notify ?? undefined;
    message.notify_reason = object.notify_reason ?? undefined;
    return message;
  },
};

function createBaseResponseMessageProto(): ResponseMessageProto {
  return { type: undefined, scenario_output: undefined, scenario_synthesis_output: undefined };
}

export const ResponseMessageProto: MessageFns<ResponseMessageProto> = {
  encode(message: ResponseMessageProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== undefined) {
      writer.uint32(8).int32(message.type);
    }
    if (message.scenario_output !== undefined) {
      ScenarioOutput.encode(message.scenario_output, writer.uint32(18).fork()).join();
    }
    if (message.scenario_synthesis_output !== undefined) {
      NotificationOutput.encode(message.scenario_synthesis_output, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ResponseMessageProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseResponseMessageProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.scenario_output = ScenarioOutput.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scenario_synthesis_output = NotificationOutput.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ResponseMessageProto {
    return {
      type: isSet(object.type) ? argsSchemaTypeFromJSON(object.type) : undefined,
      scenario_output: isSet(object.scenario_output) ? ScenarioOutput.fromJSON(object.scenario_output) : undefined,
      scenario_synthesis_output: isSet(object.scenario_synthesis_output)
        ? NotificationOutput.fromJSON(object.scenario_synthesis_output)
        : undefined,
    };
  },

  toJSON(message: ResponseMessageProto): unknown {
    const obj: any = {};
    if (message.type !== undefined) {
      obj.type = argsSchemaTypeToJSON(message.type);
    }
    if (message.scenario_output !== undefined) {
      obj.scenario_output = ScenarioOutput.toJSON(message.scenario_output);
    }
    if (message.scenario_synthesis_output !== undefined) {
      obj.scenario_synthesis_output = NotificationOutput.toJSON(message.scenario_synthesis_output);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ResponseMessageProto>, I>>(base?: I): ResponseMessageProto {
    return ResponseMessageProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ResponseMessageProto>, I>>(object: I): ResponseMessageProto {
    const message = createBaseResponseMessageProto();
    message.type = object.type ?? undefined;
    message.scenario_output = (object.scenario_output !== undefined && object.scenario_output !== null)
      ? ScenarioOutput.fromPartial(object.scenario_output)
      : undefined;
    message.scenario_synthesis_output =
      (object.scenario_synthesis_output !== undefined && object.scenario_synthesis_output !== null)
        ? NotificationOutput.fromPartial(object.scenario_synthesis_output)
        : undefined;
    return message;
  },
};

function createBaseAnalystJobRunProto(): AnalystJobRunProto {
  return { header: undefined, scenario_outputs: [], synthesis_output: undefined };
}

export const AnalystJobRunProto: MessageFns<AnalystJobRunProto> = {
  encode(message: AnalystJobRunProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.header !== undefined) {
      Header.encode(message.header, writer.uint32(10).fork()).join();
    }
    for (const v of message.scenario_outputs) {
      AnalystJobRunProto_ScenarioOutputEntry.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.synthesis_output !== undefined) {
      NotificationOutput.encode(message.synthesis_output, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalystJobRunProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalystJobRunProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.header = Header.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.scenario_outputs.push(AnalystJobRunProto_ScenarioOutputEntry.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.synthesis_output = NotificationOutput.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalystJobRunProto {
    return {
      header: isSet(object.header) ? Header.fromJSON(object.header) : undefined,
      scenario_outputs: globalThis.Array.isArray(object?.scenario_outputs)
        ? object.scenario_outputs.map((e: any) => AnalystJobRunProto_ScenarioOutputEntry.fromJSON(e))
        : [],
      synthesis_output: isSet(object.synthesis_output)
        ? NotificationOutput.fromJSON(object.synthesis_output)
        : undefined,
    };
  },

  toJSON(message: AnalystJobRunProto): unknown {
    const obj: any = {};
    if (message.header !== undefined) {
      obj.header = Header.toJSON(message.header);
    }
    if (message.scenario_outputs?.length) {
      obj.scenario_outputs = message.scenario_outputs.map((e) => AnalystJobRunProto_ScenarioOutputEntry.toJSON(e));
    }
    if (message.synthesis_output !== undefined) {
      obj.synthesis_output = NotificationOutput.toJSON(message.synthesis_output);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalystJobRunProto>, I>>(base?: I): AnalystJobRunProto {
    return AnalystJobRunProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalystJobRunProto>, I>>(object: I): AnalystJobRunProto {
    const message = createBaseAnalystJobRunProto();
    message.header = (object.header !== undefined && object.header !== null)
      ? Header.fromPartial(object.header)
      : undefined;
    message.scenario_outputs =
      object.scenario_outputs?.map((e) => AnalystJobRunProto_ScenarioOutputEntry.fromPartial(e)) || [];
    message.synthesis_output = (object.synthesis_output !== undefined && object.synthesis_output !== null)
      ? NotificationOutput.fromPartial(object.synthesis_output)
      : undefined;
    return message;
  },
};

function createBaseAnalystJobRunProto_ScenarioOutputEntry(): AnalystJobRunProto_ScenarioOutputEntry {
  return { scenario_id: undefined, scenario_output: undefined };
}

export const AnalystJobRunProto_ScenarioOutputEntry: MessageFns<AnalystJobRunProto_ScenarioOutputEntry> = {
  encode(message: AnalystJobRunProto_ScenarioOutputEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.scenario_id !== undefined) {
      writer.uint32(10).string(message.scenario_id);
    }
    if (message.scenario_output !== undefined) {
      ScenarioOutput.encode(message.scenario_output, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AnalystJobRunProto_ScenarioOutputEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAnalystJobRunProto_ScenarioOutputEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.scenario_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.scenario_output = ScenarioOutput.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AnalystJobRunProto_ScenarioOutputEntry {
    return {
      scenario_id: isSet(object.scenario_id) ? globalThis.String(object.scenario_id) : undefined,
      scenario_output: isSet(object.scenario_output) ? ScenarioOutput.fromJSON(object.scenario_output) : undefined,
    };
  },

  toJSON(message: AnalystJobRunProto_ScenarioOutputEntry): unknown {
    const obj: any = {};
    if (message.scenario_id !== undefined) {
      obj.scenario_id = message.scenario_id;
    }
    if (message.scenario_output !== undefined) {
      obj.scenario_output = ScenarioOutput.toJSON(message.scenario_output);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AnalystJobRunProto_ScenarioOutputEntry>, I>>(
    base?: I,
  ): AnalystJobRunProto_ScenarioOutputEntry {
    return AnalystJobRunProto_ScenarioOutputEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AnalystJobRunProto_ScenarioOutputEntry>, I>>(
    object: I,
  ): AnalystJobRunProto_ScenarioOutputEntry {
    const message = createBaseAnalystJobRunProto_ScenarioOutputEntry();
    message.scenario_id = object.scenario_id ?? undefined;
    message.scenario_output = (object.scenario_output !== undefined && object.scenario_output !== null)
      ? ScenarioOutput.fromPartial(object.scenario_output)
      : undefined;
    return message;
  },
};

function createBaseArtifactProto(): ArtifactProto {
  return {
    artifact_type: undefined,
    kg_observation: undefined,
    kg_dataframe: undefined,
    scenario: undefined,
    analyst_job_run: undefined,
    scenario_job: undefined,
  };
}

export const ArtifactProto: MessageFns<ArtifactProto> = {
  encode(message: ArtifactProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.artifact_type !== undefined) {
      writer.uint32(8).int32(message.artifact_type);
    }
    if (message.kg_observation !== undefined) {
      KGObservationProto.encode(message.kg_observation, writer.uint32(18).fork()).join();
    }
    if (message.kg_dataframe !== undefined) {
      KGDataFrameProto.encode(message.kg_dataframe, writer.uint32(26).fork()).join();
    }
    if (message.scenario !== undefined) {
      ScenarioAnalysis.encode(message.scenario, writer.uint32(34).fork()).join();
    }
    if (message.analyst_job_run !== undefined) {
      AnalystJobRunProto.encode(message.analyst_job_run, writer.uint32(42).fork()).join();
    }
    if (message.scenario_job !== undefined) {
      ScheduledJobProto.encode(message.scenario_job, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArtifactProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArtifactProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.artifact_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.kg_observation = KGObservationProto.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.kg_dataframe = KGDataFrameProto.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.scenario = ScenarioAnalysis.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.analyst_job_run = AnalystJobRunProto.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.scenario_job = ScheduledJobProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArtifactProto {
    return {
      artifact_type: isSet(object.artifact_type) ? artifactTypeFromJSON(object.artifact_type) : undefined,
      kg_observation: isSet(object.kg_observation) ? KGObservationProto.fromJSON(object.kg_observation) : undefined,
      kg_dataframe: isSet(object.kg_dataframe) ? KGDataFrameProto.fromJSON(object.kg_dataframe) : undefined,
      scenario: isSet(object.scenario) ? ScenarioAnalysis.fromJSON(object.scenario) : undefined,
      analyst_job_run: isSet(object.analyst_job_run) ? AnalystJobRunProto.fromJSON(object.analyst_job_run) : undefined,
      scenario_job: isSet(object.scenario_job) ? ScheduledJobProto.fromJSON(object.scenario_job) : undefined,
    };
  },

  toJSON(message: ArtifactProto): unknown {
    const obj: any = {};
    if (message.artifact_type !== undefined) {
      obj.artifact_type = artifactTypeToJSON(message.artifact_type);
    }
    if (message.kg_observation !== undefined) {
      obj.kg_observation = KGObservationProto.toJSON(message.kg_observation);
    }
    if (message.kg_dataframe !== undefined) {
      obj.kg_dataframe = KGDataFrameProto.toJSON(message.kg_dataframe);
    }
    if (message.scenario !== undefined) {
      obj.scenario = ScenarioAnalysis.toJSON(message.scenario);
    }
    if (message.analyst_job_run !== undefined) {
      obj.analyst_job_run = AnalystJobRunProto.toJSON(message.analyst_job_run);
    }
    if (message.scenario_job !== undefined) {
      obj.scenario_job = ScheduledJobProto.toJSON(message.scenario_job);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ArtifactProto>, I>>(base?: I): ArtifactProto {
    return ArtifactProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ArtifactProto>, I>>(object: I): ArtifactProto {
    const message = createBaseArtifactProto();
    message.artifact_type = object.artifact_type ?? undefined;
    message.kg_observation = (object.kg_observation !== undefined && object.kg_observation !== null)
      ? KGObservationProto.fromPartial(object.kg_observation)
      : undefined;
    message.kg_dataframe = (object.kg_dataframe !== undefined && object.kg_dataframe !== null)
      ? KGDataFrameProto.fromPartial(object.kg_dataframe)
      : undefined;
    message.scenario = (object.scenario !== undefined && object.scenario !== null)
      ? ScenarioAnalysis.fromPartial(object.scenario)
      : undefined;
    message.analyst_job_run = (object.analyst_job_run !== undefined && object.analyst_job_run !== null)
      ? AnalystJobRunProto.fromPartial(object.analyst_job_run)
      : undefined;
    message.scenario_job = (object.scenario_job !== undefined && object.scenario_job !== null)
      ? ScheduledJobProto.fromPartial(object.scenario_job)
      : undefined;
    return message;
  },
};

function createBaseChatMessageProto(): ChatMessageProto {
  return {
    message_type: undefined,
    content: undefined,
    langgraph_message_json_list: [],
    artifacts: [],
    response_message: undefined,
    ls_trace_url: undefined,
    id: undefined,
    timestamp_ms: undefined,
  };
}

export const ChatMessageProto: MessageFns<ChatMessageProto> = {
  encode(message: ChatMessageProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.message_type !== undefined) {
      writer.uint32(8).int32(message.message_type);
    }
    if (message.content !== undefined) {
      writer.uint32(18).string(message.content);
    }
    for (const v of message.langgraph_message_json_list) {
      writer.uint32(26).string(v!);
    }
    for (const v of message.artifacts) {
      ArtifactProto.encode(v!, writer.uint32(34).fork()).join();
    }
    if (message.response_message !== undefined) {
      ResponseMessageProto.encode(message.response_message, writer.uint32(42).fork()).join();
    }
    if (message.ls_trace_url !== undefined) {
      writer.uint32(50).string(message.ls_trace_url);
    }
    if (message.id !== undefined) {
      writer.uint32(58).string(message.id);
    }
    if (message.timestamp_ms !== undefined) {
      writer.uint32(64).int64(message.timestamp_ms);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatMessageProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatMessageProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.message_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.langgraph_message_json_list.push(reader.string());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.artifacts.push(ArtifactProto.decode(reader, reader.uint32()));
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.response_message = ResponseMessageProto.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.ls_trace_url = reader.string();
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.timestamp_ms = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatMessageProto {
    return {
      message_type: isSet(object.message_type) ? chatMessageTypeFromJSON(object.message_type) : undefined,
      content: isSet(object.content) ? globalThis.String(object.content) : undefined,
      langgraph_message_json_list: globalThis.Array.isArray(object?.langgraph_message_json_list)
        ? object.langgraph_message_json_list.map((e: any) => globalThis.String(e))
        : [],
      artifacts: globalThis.Array.isArray(object?.artifacts)
        ? object.artifacts.map((e: any) => ArtifactProto.fromJSON(e))
        : [],
      response_message: isSet(object.response_message)
        ? ResponseMessageProto.fromJSON(object.response_message)
        : undefined,
      ls_trace_url: isSet(object.ls_trace_url) ? globalThis.String(object.ls_trace_url) : undefined,
      id: isSet(object.id) ? globalThis.String(object.id) : undefined,
      timestamp_ms: isSet(object.timestamp_ms) ? globalThis.Number(object.timestamp_ms) : undefined,
    };
  },

  toJSON(message: ChatMessageProto): unknown {
    const obj: any = {};
    if (message.message_type !== undefined) {
      obj.message_type = chatMessageTypeToJSON(message.message_type);
    }
    if (message.content !== undefined) {
      obj.content = message.content;
    }
    if (message.langgraph_message_json_list?.length) {
      obj.langgraph_message_json_list = message.langgraph_message_json_list;
    }
    if (message.artifacts?.length) {
      obj.artifacts = message.artifacts.map((e) => ArtifactProto.toJSON(e));
    }
    if (message.response_message !== undefined) {
      obj.response_message = ResponseMessageProto.toJSON(message.response_message);
    }
    if (message.ls_trace_url !== undefined) {
      obj.ls_trace_url = message.ls_trace_url;
    }
    if (message.id !== undefined) {
      obj.id = message.id;
    }
    if (message.timestamp_ms !== undefined) {
      obj.timestamp_ms = Math.round(message.timestamp_ms);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatMessageProto>, I>>(base?: I): ChatMessageProto {
    return ChatMessageProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatMessageProto>, I>>(object: I): ChatMessageProto {
    const message = createBaseChatMessageProto();
    message.message_type = object.message_type ?? undefined;
    message.content = object.content ?? undefined;
    message.langgraph_message_json_list = object.langgraph_message_json_list?.map((e) => e) || [];
    message.artifacts = object.artifacts?.map((e) => ArtifactProto.fromPartial(e)) || [];
    message.response_message = (object.response_message !== undefined && object.response_message !== null)
      ? ResponseMessageProto.fromPartial(object.response_message)
      : undefined;
    message.ls_trace_url = object.ls_trace_url ?? undefined;
    message.id = object.id ?? undefined;
    message.timestamp_ms = object.timestamp_ms ?? undefined;
    return message;
  },
};

function createBaseAgentInputProto(): AgentInputProto {
  return {
    trees: [],
    plans: [],
    custom_agents: [],
    analyst: undefined,
    scheduled_job: undefined,
    override_jinja_variables: undefined,
    scenario_jobs: [],
  };
}

export const AgentInputProto: MessageFns<AgentInputProto> = {
  encode(message: AgentInputProto, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.trees) {
      AnalysisTreeProto.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.plans) {
      AnalysisPlanProto.encode(v!, writer.uint32(18).fork()).join();
    }
    for (const v of message.custom_agents) {
      CustomAgentProto.encode(v!, writer.uint32(26).fork()).join();
    }
    if (message.analyst !== undefined) {
      AnalystProto.encode(message.analyst, writer.uint32(34).fork()).join();
    }
    if (message.scheduled_job !== undefined) {
      ScheduledJobProto.encode(message.scheduled_job, writer.uint32(42).fork()).join();
    }
    if (message.override_jinja_variables !== undefined) {
      AgentInputProto_OverrideVariables.encode(message.override_jinja_variables, writer.uint32(50).fork()).join();
    }
    for (const v of message.scenario_jobs) {
      ScheduledJobProto.encode(v!, writer.uint32(58).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentInputProto {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentInputProto();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.trees.push(AnalysisTreeProto.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.plans.push(AnalysisPlanProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.custom_agents.push(CustomAgentProto.decode(reader, reader.uint32()));
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.analyst = AnalystProto.decode(reader, reader.uint32());
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.scheduled_job = ScheduledJobProto.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.override_jinja_variables = AgentInputProto_OverrideVariables.decode(reader, reader.uint32());
          continue;
        }
        case 7: {
          if (tag !== 58) {
            break;
          }

          message.scenario_jobs.push(ScheduledJobProto.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentInputProto {
    return {
      trees: globalThis.Array.isArray(object?.trees) ? object.trees.map((e: any) => AnalysisTreeProto.fromJSON(e)) : [],
      plans: globalThis.Array.isArray(object?.plans) ? object.plans.map((e: any) => AnalysisPlanProto.fromJSON(e)) : [],
      custom_agents: globalThis.Array.isArray(object?.custom_agents)
        ? object.custom_agents.map((e: any) => CustomAgentProto.fromJSON(e))
        : [],
      analyst: isSet(object.analyst) ? AnalystProto.fromJSON(object.analyst) : undefined,
      scheduled_job: isSet(object.scheduled_job) ? ScheduledJobProto.fromJSON(object.scheduled_job) : undefined,
      override_jinja_variables: isSet(object.override_jinja_variables)
        ? AgentInputProto_OverrideVariables.fromJSON(object.override_jinja_variables)
        : undefined,
      scenario_jobs: globalThis.Array.isArray(object?.scenario_jobs)
        ? object.scenario_jobs.map((e: any) => ScheduledJobProto.fromJSON(e))
        : [],
    };
  },

  toJSON(message: AgentInputProto): unknown {
    const obj: any = {};
    if (message.trees?.length) {
      obj.trees = message.trees.map((e) => AnalysisTreeProto.toJSON(e));
    }
    if (message.plans?.length) {
      obj.plans = message.plans.map((e) => AnalysisPlanProto.toJSON(e));
    }
    if (message.custom_agents?.length) {
      obj.custom_agents = message.custom_agents.map((e) => CustomAgentProto.toJSON(e));
    }
    if (message.analyst !== undefined) {
      obj.analyst = AnalystProto.toJSON(message.analyst);
    }
    if (message.scheduled_job !== undefined) {
      obj.scheduled_job = ScheduledJobProto.toJSON(message.scheduled_job);
    }
    if (message.override_jinja_variables !== undefined) {
      obj.override_jinja_variables = AgentInputProto_OverrideVariables.toJSON(message.override_jinja_variables);
    }
    if (message.scenario_jobs?.length) {
      obj.scenario_jobs = message.scenario_jobs.map((e) => ScheduledJobProto.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentInputProto>, I>>(base?: I): AgentInputProto {
    return AgentInputProto.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentInputProto>, I>>(object: I): AgentInputProto {
    const message = createBaseAgentInputProto();
    message.trees = object.trees?.map((e) => AnalysisTreeProto.fromPartial(e)) || [];
    message.plans = object.plans?.map((e) => AnalysisPlanProto.fromPartial(e)) || [];
    message.custom_agents = object.custom_agents?.map((e) => CustomAgentProto.fromPartial(e)) || [];
    message.analyst = (object.analyst !== undefined && object.analyst !== null)
      ? AnalystProto.fromPartial(object.analyst)
      : undefined;
    message.scheduled_job = (object.scheduled_job !== undefined && object.scheduled_job !== null)
      ? ScheduledJobProto.fromPartial(object.scheduled_job)
      : undefined;
    message.override_jinja_variables =
      (object.override_jinja_variables !== undefined && object.override_jinja_variables !== null)
        ? AgentInputProto_OverrideVariables.fromPartial(object.override_jinja_variables)
        : undefined;
    message.scenario_jobs = object.scenario_jobs?.map((e) => ScheduledJobProto.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAgentInputProto_OverrideVariables(): AgentInputProto_OverrideVariables {
  return { today_date: undefined, company_name: undefined, week_start_day: undefined, quarter_start_month: undefined };
}

export const AgentInputProto_OverrideVariables: MessageFns<AgentInputProto_OverrideVariables> = {
  encode(message: AgentInputProto_OverrideVariables, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.today_date !== undefined) {
      writer.uint32(10).string(message.today_date);
    }
    if (message.company_name !== undefined) {
      writer.uint32(18).string(message.company_name);
    }
    if (message.week_start_day !== undefined) {
      writer.uint32(26).string(message.week_start_day);
    }
    if (message.quarter_start_month !== undefined) {
      writer.uint32(34).string(message.quarter_start_month);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentInputProto_OverrideVariables {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentInputProto_OverrideVariables();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.today_date = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.company_name = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.week_start_day = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.quarter_start_month = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentInputProto_OverrideVariables {
    return {
      today_date: isSet(object.today_date) ? globalThis.String(object.today_date) : undefined,
      company_name: isSet(object.company_name) ? globalThis.String(object.company_name) : undefined,
      week_start_day: isSet(object.week_start_day) ? globalThis.String(object.week_start_day) : undefined,
      quarter_start_month: isSet(object.quarter_start_month)
        ? globalThis.String(object.quarter_start_month)
        : undefined,
    };
  },

  toJSON(message: AgentInputProto_OverrideVariables): unknown {
    const obj: any = {};
    if (message.today_date !== undefined) {
      obj.today_date = message.today_date;
    }
    if (message.company_name !== undefined) {
      obj.company_name = message.company_name;
    }
    if (message.week_start_day !== undefined) {
      obj.week_start_day = message.week_start_day;
    }
    if (message.quarter_start_month !== undefined) {
      obj.quarter_start_month = message.quarter_start_month;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentInputProto_OverrideVariables>, I>>(
    base?: I,
  ): AgentInputProto_OverrideVariables {
    return AgentInputProto_OverrideVariables.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentInputProto_OverrideVariables>, I>>(
    object: I,
  ): AgentInputProto_OverrideVariables {
    const message = createBaseAgentInputProto_OverrideVariables();
    message.today_date = object.today_date ?? undefined;
    message.company_name = object.company_name ?? undefined;
    message.week_start_day = object.week_start_day ?? undefined;
    message.quarter_start_month = object.quarter_start_month ?? undefined;
    return message;
  },
};

function createBaseAgentScenarioMapping(): AgentScenarioMapping {
  return { llm_id: undefined, scenario_id: undefined };
}

export const AgentScenarioMapping: MessageFns<AgentScenarioMapping> = {
  encode(message: AgentScenarioMapping, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.llm_id !== undefined) {
      writer.uint32(10).string(message.llm_id);
    }
    if (message.scenario_id !== undefined) {
      writer.uint32(18).string(message.scenario_id);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AgentScenarioMapping {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgentScenarioMapping();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.llm_id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.scenario_id = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgentScenarioMapping {
    return {
      llm_id: isSet(object.llm_id) ? globalThis.String(object.llm_id) : undefined,
      scenario_id: isSet(object.scenario_id) ? globalThis.String(object.scenario_id) : undefined,
    };
  },

  toJSON(message: AgentScenarioMapping): unknown {
    const obj: any = {};
    if (message.llm_id !== undefined) {
      obj.llm_id = message.llm_id;
    }
    if (message.scenario_id !== undefined) {
      obj.scenario_id = message.scenario_id;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgentScenarioMapping>, I>>(base?: I): AgentScenarioMapping {
    return AgentScenarioMapping.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgentScenarioMapping>, I>>(object: I): AgentScenarioMapping {
    const message = createBaseAgentScenarioMapping();
    message.llm_id = object.llm_id ?? undefined;
    message.scenario_id = object.scenario_id ?? undefined;
    return message;
  },
};

function createBaseChatResponse(): ChatResponse {
  return {
    session_header: undefined,
    messages: [],
    status: undefined,
    analyst_id: undefined,
    saved_scenario_agent_mapping: [],
  };
}

export const ChatResponse: MessageFns<ChatResponse> = {
  encode(message: ChatResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.session_header !== undefined) {
      DarwinHeader.encode(message.session_header, writer.uint32(10).fork()).join();
    }
    for (const v of message.messages) {
      ChatMessageProto.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.status !== undefined) {
      writer.uint32(24).int32(message.status);
    }
    if (message.analyst_id !== undefined) {
      writer.uint32(34).string(message.analyst_id);
    }
    for (const v of message.saved_scenario_agent_mapping) {
      AgentScenarioMapping.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.session_header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.messages.push(ChatMessageProto.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.analyst_id = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.saved_scenario_agent_mapping.push(AgentScenarioMapping.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatResponse {
    return {
      session_header: isSet(object.session_header) ? DarwinHeader.fromJSON(object.session_header) : undefined,
      messages: globalThis.Array.isArray(object?.messages)
        ? object.messages.map((e: any) => ChatMessageProto.fromJSON(e))
        : [],
      status: isSet(object.status) ? executionStatusTypeFromJSON(object.status) : undefined,
      analyst_id: isSet(object.analyst_id) ? globalThis.String(object.analyst_id) : undefined,
      saved_scenario_agent_mapping: globalThis.Array.isArray(object?.saved_scenario_agent_mapping)
        ? object.saved_scenario_agent_mapping.map((e: any) => AgentScenarioMapping.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ChatResponse): unknown {
    const obj: any = {};
    if (message.session_header !== undefined) {
      obj.session_header = DarwinHeader.toJSON(message.session_header);
    }
    if (message.messages?.length) {
      obj.messages = message.messages.map((e) => ChatMessageProto.toJSON(e));
    }
    if (message.status !== undefined) {
      obj.status = executionStatusTypeToJSON(message.status);
    }
    if (message.analyst_id !== undefined) {
      obj.analyst_id = message.analyst_id;
    }
    if (message.saved_scenario_agent_mapping?.length) {
      obj.saved_scenario_agent_mapping = message.saved_scenario_agent_mapping.map((e) =>
        AgentScenarioMapping.toJSON(e)
      );
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatResponse>, I>>(base?: I): ChatResponse {
    return ChatResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatResponse>, I>>(object: I): ChatResponse {
    const message = createBaseChatResponse();
    message.session_header = (object.session_header !== undefined && object.session_header !== null)
      ? DarwinHeader.fromPartial(object.session_header)
      : undefined;
    message.messages = object.messages?.map((e) => ChatMessageProto.fromPartial(e)) || [];
    message.status = object.status ?? undefined;
    message.analyst_id = object.analyst_id ?? undefined;
    message.saved_scenario_agent_mapping =
      object.saved_scenario_agent_mapping?.map((e) => AgentScenarioMapping.fromPartial(e)) || [];
    return message;
  },
};

function createBaseChatContext(): ChatContext {
  return { agent_type: undefined, agent_header: undefined, prompt_header: undefined, agent_input: undefined };
}

export const ChatContext: MessageFns<ChatContext> = {
  encode(message: ChatContext, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.agent_type !== undefined) {
      writer.uint32(8).int32(message.agent_type);
    }
    if (message.agent_header !== undefined) {
      DarwinHeader.encode(message.agent_header, writer.uint32(18).fork()).join();
    }
    if (message.prompt_header !== undefined) {
      DarwinHeader.encode(message.prompt_header, writer.uint32(26).fork()).join();
    }
    if (message.agent_input !== undefined) {
      AgentInputProto.encode(message.agent_input, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatContext {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatContext();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.agent_type = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.agent_header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.prompt_header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.agent_input = AgentInputProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatContext {
    return {
      agent_type: isSet(object.agent_type) ? darwinAgentTypeFromJSON(object.agent_type) : undefined,
      agent_header: isSet(object.agent_header) ? DarwinHeader.fromJSON(object.agent_header) : undefined,
      prompt_header: isSet(object.prompt_header) ? DarwinHeader.fromJSON(object.prompt_header) : undefined,
      agent_input: isSet(object.agent_input) ? AgentInputProto.fromJSON(object.agent_input) : undefined,
    };
  },

  toJSON(message: ChatContext): unknown {
    const obj: any = {};
    if (message.agent_type !== undefined) {
      obj.agent_type = darwinAgentTypeToJSON(message.agent_type);
    }
    if (message.agent_header !== undefined) {
      obj.agent_header = DarwinHeader.toJSON(message.agent_header);
    }
    if (message.prompt_header !== undefined) {
      obj.prompt_header = DarwinHeader.toJSON(message.prompt_header);
    }
    if (message.agent_input !== undefined) {
      obj.agent_input = AgentInputProto.toJSON(message.agent_input);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatContext>, I>>(base?: I): ChatContext {
    return ChatContext.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatContext>, I>>(object: I): ChatContext {
    const message = createBaseChatContext();
    message.agent_type = object.agent_type ?? undefined;
    message.agent_header = (object.agent_header !== undefined && object.agent_header !== null)
      ? DarwinHeader.fromPartial(object.agent_header)
      : undefined;
    message.prompt_header = (object.prompt_header !== undefined && object.prompt_header !== null)
      ? DarwinHeader.fromPartial(object.prompt_header)
      : undefined;
    message.agent_input = (object.agent_input !== undefined && object.agent_input !== null)
      ? AgentInputProto.fromPartial(object.agent_input)
      : undefined;
    return message;
  },
};

function createBaseChatRequest(): ChatRequest {
  return {
    session_header: undefined,
    chat_context: undefined,
    message: undefined,
    is_save: undefined,
    user_context: undefined,
  };
}

export const ChatRequest: MessageFns<ChatRequest> = {
  encode(message: ChatRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.session_header !== undefined) {
      DarwinHeader.encode(message.session_header, writer.uint32(10).fork()).join();
    }
    if (message.chat_context !== undefined) {
      ChatContext.encode(message.chat_context, writer.uint32(18).fork()).join();
    }
    if (message.message !== undefined) {
      writer.uint32(26).string(message.message);
    }
    if (message.is_save !== undefined) {
      writer.uint32(32).bool(message.is_save);
    }
    if (message.user_context !== undefined) {
      ArtifactProto.encode(message.user_context, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ChatRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseChatRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.session_header = DarwinHeader.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.chat_context = ChatContext.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.message = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.is_save = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.user_context = ArtifactProto.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ChatRequest {
    return {
      session_header: isSet(object.session_header) ? DarwinHeader.fromJSON(object.session_header) : undefined,
      chat_context: isSet(object.chat_context) ? ChatContext.fromJSON(object.chat_context) : undefined,
      message: isSet(object.message) ? globalThis.String(object.message) : undefined,
      is_save: isSet(object.is_save) ? globalThis.Boolean(object.is_save) : undefined,
      user_context: isSet(object.user_context) ? ArtifactProto.fromJSON(object.user_context) : undefined,
    };
  },

  toJSON(message: ChatRequest): unknown {
    const obj: any = {};
    if (message.session_header !== undefined) {
      obj.session_header = DarwinHeader.toJSON(message.session_header);
    }
    if (message.chat_context !== undefined) {
      obj.chat_context = ChatContext.toJSON(message.chat_context);
    }
    if (message.message !== undefined) {
      obj.message = message.message;
    }
    if (message.is_save !== undefined) {
      obj.is_save = message.is_save;
    }
    if (message.user_context !== undefined) {
      obj.user_context = ArtifactProto.toJSON(message.user_context);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ChatRequest>, I>>(base?: I): ChatRequest {
    return ChatRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ChatRequest>, I>>(object: I): ChatRequest {
    const message = createBaseChatRequest();
    message.session_header = (object.session_header !== undefined && object.session_header !== null)
      ? DarwinHeader.fromPartial(object.session_header)
      : undefined;
    message.chat_context = (object.chat_context !== undefined && object.chat_context !== null)
      ? ChatContext.fromPartial(object.chat_context)
      : undefined;
    message.message = object.message ?? undefined;
    message.is_save = object.is_save ?? undefined;
    message.user_context = (object.user_context !== undefined && object.user_context !== null)
      ? ArtifactProto.fromPartial(object.user_context)
      : undefined;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
